import RouteTemplate from 'ember-route-template';

import { concat } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

import CatalogDetailAssociatedItems from 'rise-ui/components/catalog/detail/associated-items.gjs';
import CatalogDetailDetail from 'rise-ui/components/catalog/detail/detail.gjs';
import CatalogDetailLocation from 'rise-ui/components/catalog/detail/location.gjs';
import CatalogDetailRelatedLocations from 'rise-ui/components/catalog/detail/related-locations.gjs';
import CatalogDetailMeta from 'rise-ui/components/catalog/detail/meta.gjs';
import CatalogDetailRelatedRecords from 'rise-ui/components/catalog/detail/related-records.gjs';
import string from 'rise-ui/helpers/string.js';
import { readOnly } from 'rise-ui/utils/object/computed.js';

export default RouteTemplate(class CatalogRecordIndexTemplate extends Component {
  @service store;

  @readOnly('@model.recordsWithGenerationEffort') recordsWithGenerationEffort;
  @readOnly('@model.otherCatalogRecordsForLocation') otherCatalogRecordsForLocation;
  @readOnly('@model.record.location') location;

  <template>
    {{pageTitle (concat "Record " @model.record.id)}}
    {{pageTitle @model.record.title}}

    <div class="id-catalog-record">
      <h3 class="c-page-title id-catalog-record__page-title qa-page-title">
        {{~string "record-heading"~}}
      </h3>
      <h3 class="id-catalog-record__title qa-record-title">{{@model.record.title}}</h3>
      <div class="id-catalog-record__description">{{@model.record.description}}</div>
      <CatalogDetailDetail
        @record={{@model.record}}
      />
      <CatalogDetailAssociatedItems
        @record={{@model.record}}
      />
      <CatalogDetailLocation
        @location={{@model.record.location}}
      />
      <CatalogDetailRelatedLocations
        @location={{@model.record.location}}
      />
      <CatalogDetailRelatedRecords
        @record={{@model.record}}
        @otherRecordsForGenerationEffort={{@model.otherRecordsForGenerationEffort}}
        @otherRecordsForLocation={{@model.otherRecordsForLocation}}
      />
      <CatalogDetailMeta
        @record={{@model.record}}
      />
    </div>
    {{outlet}}
  </template>
});
